import { render, staticRenderFns } from "./EditOpeningHoursPolicy.vue?vue&type=template&id=dc882b84&"
import script from "./EditOpeningHoursPolicy.vue?vue&type=script&lang=js&"
export * from "./EditOpeningHoursPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports